import { Type } from '@angular/core';
import { ICommunityContextDashboardComponent } from '../_interfaces/community-context-component';
import { IDynamicDashboardComponent } from '../_interfaces/dynamic-dashboard-component';
import { IInteractiveDashboardComponent } from '../_interfaces/interactive-dashboard-component';

export class DynamicDashboardWidget {
    id: string;
    name: string;
    code: string;
    helpLink: string;
    hasContext: boolean;
    isInteractive: boolean;

    component: Type<IDynamicDashboardComponent | ICommunityContextDashboardComponent | IInteractiveDashboardComponent>;
    category: string;
    subCategory: string;

    constructor(
        id: string,
        code: string,
        name: string,
        component: Type<
            IDynamicDashboardComponent | ICommunityContextDashboardComponent | IInteractiveDashboardComponent
        >,
        hasContext = false,
        isInteractive = false,
        helpLink = null
    ) {
        this.id = id;
        this.code = code;
        this.name = name;
        this.hasContext = hasContext;
        this.isInteractive = isInteractive;
        this.helpLink = helpLink;
        this.component = component;
    }

    groupByCategory(category: string): DynamicDashboardWidget {
        this.category = category;
        return this;
    }

    groupBySubCategory(subCategory: string): DynamicDashboardWidget {
        this.category = this.category || subCategory;
        this.subCategory = subCategory;
        return this;
    }

    groupBy(category: string, subCategory: string): DynamicDashboardWidget {
        return this.groupByCategory(category).groupBySubCategory(subCategory);
    }
}
